import React from 'react'
import { connect } from "react-redux"
import sortBy from 'lodash/sortBy'
import PracticeUserRow from './PracticeUserRow'
//import PracticeHeader from '../practice/PracticeHeader'
import PracticeAdminMenu from './PracticeAdminMenu'
import { fetchPracticeUsers, addUserToPractice, moveUserToPracticePending, removeUserFromPractice } from "../../actions/practiceAdmin"
import { setTitle, fetchPractice } from "../../actions/index"
import { Tooltip } from 'react-tippy';
import SearchIcon from '../../images/icons/SearchIcon'

import { withRouter } from 'react-router'
import { users } from '../../reducers';
import loaderImg from '../practice_admin/images/loader.gif'

//import styles
//import './styles/Practice.scss';


@connect((store) => {
	return {
		User: store.User.User,
		app: store.app
	}
})
class PracticeAdminUsers extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tipOpen: true,
			filterBy: '',
			sortBy: '',
			search: '',
			loading: true
		}

		this.getPracticeUsers = this.getPracticeUsers.bind(this)
		this.ownerAuth = this.ownerAuth.bind(this)
		this.toggleTherapist = this.toggleTherapist.bind(this)
		this.toggleParent = this.toggleParent.bind(this)
		this.getPractice = this.getPractice.bind(this)
		this.closeTooltip = this.closeTooltip.bind(this)
		this.filterChange = this.filterChange.bind(this)
		this.handleChange = this.handleChange.bind(this)
		this.onSearchChange = this.onSearchChange.bind(this)
		this.removeUser = this.removeUser.bind(this)
		this.getUsers = this.getUsers.bind(this)
		this.isParent = this.isParent.bind(this)
		this.isTherapist = this.isTherapist.bind(this)
	}

	componentDidUpdate(nextProps) {
		if (nextProps.app.practice.name !== this.props.app.practice.name) {
			this.setState({ shouldGetPendingUsers: true })
			this.getPractice()
		}

		if (this.props.User.name != nextProps.User.name) {
			this.getPractice()
			this.ownerAuth()
		}
	}

	componentWillMount() {
		this.getPractice().then(() => {
			this.setState({loading: false})
		})
	}

	onSearchChange(event) {
		this.setState({ search: event.target.value });
	}

	componentWillUnmount() {
		// const { tipOpen } = this.state;
		// tipOpen && this.closeTooltip()
	}

	componentDidMount() {
		// let seenUsersList = window.localStorage.getItem('seen-users-list') || 0
		// if ((seenUsersList / 1) < 3) {
		// 	this.setState({
		// 		'tipOpen': true
		// 	})
		// }
	}

	closeTooltip() {
		const seenUsersList = window.localStorage.getItem('seen-users-list') || 0;

		window.localStorage.setItem('seen-users-list', (seenUsersList / 1) + 1)
		this.setState({
			'tipOpen': false
		})
	}

	filterChange(event) {
		this.setState({ filterBy: event.target.value });
	}

	handleChange(event) {
		this.setState({ sortBy: event.target.value });
	}

	getPractice() {
		const { dispatch, app } = this.props;
		return this.props.dispatch(
			fetchPractice(this.props.params.name)
		).then(() => {
			dispatch(setTitle(`${app.practice.name} users`))
			this.getPracticeUsers()
		})
	}

	isParent(userId) {
		return (this.props.app.practice.parents && this.props.app.practice.parents.indexOf(userId) > -1);
	}

	isTherapist(userId) {
		return (this.props.app.practice.therapists && this.props.app.practice.therapists.indexOf(userId) > -1);
	}

	toggleTherapist(userId) {
		if (this.isTherapist(userId)) {
			// remove them
			this.props.dispatch(moveUserToPracticePending('therapists', userId, this.props.app.practice._id)).then((d) => {
				this.getPracticeUsers();
			});
		} else {
			// add them
			this.props.dispatch(addUserToPractice('therapists', userId, this.props.app.practice._id)).then((d) => {
				this.getPracticeUsers();
			});
		}
	}

	toggleParent(userId) {
		if (this.isParent(userId)) {
			// remove them
			this.props.dispatch(moveUserToPracticePending('parents', userId, this.props.app.practice._id)).then((d) => {
				this.getPracticeUsers();
			});
		} else {
			// add them
			this.props.dispatch(addUserToPractice('parents', userId, this.props.app.practice._id)).then((d) => {
				this.getPracticeUsers();
			});
		}
	}

	getPracticeUsers() {
		this.props.dispatch(fetchPracticeUsers('pending_users', this.props.app.practice._id))
		this.props.dispatch(fetchPracticeUsers('parents', this.props.app.practice._id))
		this.props.dispatch(fetchPracticeUsers('therapists', this.props.app.practice._id))
	}

	ownerAuth() {
		const { app, User, params, router } = this.props;
		// is this not an owner of this practice?

		if (!app.authed) return false;

		if (!User.ownPractices
			.find(p => params.name === p.id || params.name === p.slug)) {
			router && router.replace('/');
			return false
		}
		return true
	}

	removeUser(userId) {
		if (window.confirm('Are you sure you want to remove this user from your practice?')) {
			if (this.isParent(userId)){
				// remove them
				this.props.dispatch(moveUserToPracticePending('parents', userId, this.props.app.practice._id))
			}

			if (this.isTherapist(userId)) {
				// remove them
				this.props.dispatch(moveUserToPracticePending('therapists', userId, this.props.app.practice._id))
			}

			//remove from practice
			this.props.dispatch(removeUserFromPractice(userId, this.props.app.practice._id))
		}
	}

	getUsers(type = 'assigned') {
		let pendingUsers = this.props.app.practice.pendingUsers;
		const therapists = this.props.app.practice.therapists;
		const parents = this.props.app.practice.parents;

		pendingUsers = pendingUsers.filter(function (user) {
			if (type === 'assigned') {
				if (user.parent || user.therapist) {
					let found = undefined;
					found = therapists.find((therapist) => {
						return therapist === user.id;
					});

					if (found !== undefined) {
						return user;
					} else {
						found = parents.find((parent) => {
							return parent === user.id;
						});

						if (found !== undefined) {
							return user;
						}
					}
				}
			} else {
				let found1 = undefined;
				let found2 = undefined;
				found1 = therapists.find((therapist) => {
					return therapist === user.id;
				});

				found2 = parents.find((parent) => {
					return parent === user.id;
				})
				// console.log(user);
				// console.log(found1);
				// console.log(found2);

				if (found1 === undefined && found2 === undefined) {
					return user;
				}
			}
		});

		return pendingUsers;
	}


	render() {
		const { params } = this.props;
		const { tipOpen, loading } = this.state;
		// console.log(this.props.app.practice);
		let _users = this.getUsers();
		const unassignedUsers = this.getUsers('unassigned');
		// console.log(unassignedUsers);

		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

		if (this.state.search.length > 0) {
			let search = this.state.search;

			_users = _users.filter(function (user) {
				return user.name.toLowerCase().match(search.trim().toLowerCase());
			});
		}
		let admin = this.props.params.name

		return (
			<main className="main practice-page users">
				<PracticeAdminMenu active="users" params={params} />
				{
					(unassignedUsers.length > 0) &&
						<div className="page mb8">
							<p><b>Pending</b></p>
							<ul className="md-list wide">
								{
									(sortBy(unassignedUsers, [((this.state.sortBy == 'created') ? (this.state.sortBy) : (user => {
										if (user.name) return user.name.toLowerCase()
										return 11
									}))])
										.map((user, i) => <PracticeUserRow
											key={`parents-${user._id}`}
											handleToggleTherapist={() => this.toggleTherapist(user._id)}
											handleToggleParent={() => this.toggleParent(user._id)}
											isTherapist={this.isTherapist(user._id)}
											isParent={this.isParent(user._id)}
											user={user}
											admin={admin}
											remove={() => this.removeUser(user._id)}/>
										))
								}
							</ul>
						</div>
				}
					<div>
						<p><b>Assigned</b></p>
							<div >
								<div className="search-box__content">
									<div className="search-box__input">
										<SearchIcon />
										<input type="search" onChange={this.onSearchChange} value={this.state.search} placeholder="Search for Users" />
									</div>
								</div>
							</div>
					</div>
				{
					(_users.length > 0) ?
						<div className="page heigth110">
							<div className="filterRow">
								Filter By:<select value={this.state.filterBy} onChange={this.filterChange}>
									<option value="">All</option>
									<option value="parent">Parent</option>
									<option value="therapist">Therapist</option>
								</select>

								Sort By:<select value={this.state.sortBy} onChange={this.handleChange}>
									<option value="name">Name</option>
									<option value="created">Date</option>
								</select>
							</div>

							<Tooltip
								className="md-list"
								title="Mark users as Users and/or Therapists"
								open={tipOpen}
								trigger="manual"
								position="top"
								arrow={true}
								hideDelay={4}
								duration={1000}
								unmountHTMLWhenHide={true}
								onRequestClose={this.closeTooltip}
								size="big"
							>
								<div >&nbsp;</div>
							</Tooltip>
							<ul className="md-list wide">
								{
									((this.state.filterBy == '') ? (sortBy(_users, [((this.state.sortBy == 'created') ? (this.state.sortBy) : (user => {
										if (user.name) return user.name.toLowerCase()
										return 11
									}))])
										.map((user, i) => <PracticeUserRow
											key={`parents-${user._id}`}
											handleToggleTherapist={() => this.toggleTherapist(user._id)}
											handleToggleParent={() => this.toggleParent(user._id)}
											isTherapist={this.isTherapist(user._id)}
											isParent={this.isParent(user._id)}
											user={user}
											admin={admin}
											// remove= {() => this.removeUser(user._id)}
											/>
										))
										:
										(sortBy(_users, [((this.state.sortBy == 'created') ? (this.state.sortBy) : (user => {
											if (user.name) return user.name.toLowerCase()
											return 11
										}))])
											.filter(user => ((this.state.filterBy == 'therapist') ? (this.isTherapist(user._id)) : (this.isParent(user._id))))
											.map((user, i) => <PracticeUserRow
												key={`parents-${user._id}`}
												handleToggleTherapist={() => this.toggleTherapist(user._id)}
												handleToggleParent={() => this.toggleParent(user._id)}
												isTherapist={this.isTherapist(user._id)}
												isParent={this.isParent(user._id)}
												user={user}
												admin={admin}
												// remove= {() => this.removeUser(user._id)}
												/>
											)))
								}
							</ul>							
						</div>
						:
							<div>
								No users could be found.
							</div>
				}
			</main>
		)
	}
}

class ChildOption extends React.Component {
	propTypes: {
		name: React.PropTypes.string,
		value: React.PropTypes.string,
	};

	render() {
		return (
			<option value={this.props.value}>{this.props.name}</option>
		)
	}
}

export default withRouter(PracticeAdminUsers);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeAdminUsers.jsx